/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { HTTP_REQUEST_METHODS } from "../constants/js-constants.es6.js";
var ApiErrorHandler = function () {
  function ApiErrorHandler() {
    _classCallCheck(this, ApiErrorHandler);
  }
  return _createClass(ApiErrorHandler, null, [{
    key: "handleError",
    value: function handleError(statusCode, statusText, method, path, body, clientErrorMessage, redirectPage) {
      var message = "[".concat(statusCode, "/").concat(statusText, "] ").concat(method, " ").concat(path);
      if (body) {
        message += " (response: ".concat(JSON.stringify(body), ")");
      }
      console.error(message);
      if (clientErrorMessage) {
        console.error(clientErrorMessage);
      }
      if (redirectPage) {
        window.location = redirectPage;
      }
      if (method !== HTTP_REQUEST_METHODS.GET) {
        throw Error("Method ".concat(method, " has failed: ").concat(message));
      }
    }
  }]);
}();
export { ApiErrorHandler as default };